
<label>
  <slot>{{ label }}</slot>
  <span v-if="required" class="red-asterisk">*</span>
</label>
